import gql from 'graphql-tag';

export const GET_TEAM = gql`
  query team($id: String, $displayName: String) {
    team(id: $id, displayName: $displayName) {
      team_id
      display_name
    }
  }
`;

export const CREATE_TEAM = gql`
  mutation createTeam($team: TeamInput!) {
    createTeam(team: $team) {
      team_id
      display_name
    }
  }
`;

export const getAllRoles = gql`
{allRoles{
  roleIdentifier{
    name,
    team,
    displayName
  },
  permissions{
    action,
    resource,
    allowed
  }
}}
`;

export const GET_TEAMS = gql`
  query teamsForCurrentUser {
    teamsForCurrentUser {
      team_id
      display_name
      user_role
    }
  }
`;

export const TEAM_LIST = gql`
  query($tfilter: String!, $skip: Int!, $limit: Int!) {
    teamList(tfilter: $tfilter, skip: $skip, limit: $limit) {
      teamList {
        team_id
        display_name
      }
      skip
      limit
      count
    }
  }
`;

export const GET_USERS_FOR_TEAM = gql`
  query usersForTeam($id: String!) {
    usersForTeam(id: $id) {
      team {
        team_id
        display_name
      }
      users {
        user_id
        auminfo {
          user_name
          profile_url
          email
          roles
        }
      }
    }
    getProvisionedUsers (team: $id, skip: 0, limit: 100) {
      users {
        domain,
        profile,
        role,
        user_email,
      }
    }
  }
`;

export const ASSOCIATE_USER_WITH_TEAM = gql`
  mutation associateUserWithTeam(
    $userId: String!
    $teamId: String!
    $role: String!
  ) {
    associateUserWithTeam(userId: $userId, teamId: $teamId, role: $role) {
      user_id
      auminfo {
        user_name
        profile_url
        email
        roles
      }
    }
  }
`;

export const ASSOCIATE_NEW_USER_WITH_TEAM = gql`
mutation provisionUserWithTeam ($email: String!, $teamId: String!, $role: String!) {
  provisionUserWithTeam (email: $email, teamId: $teamId, role: $role) {
    domain,
    profile,
    role,
    user_email,
  }
}
`;

export const REMOVE_USER_FROM_TEAM = gql`
  mutation removeUserFromTeam($userId: String!, $teamId: String!) {
    removeUserFromTeam(userId: $userId, teamId: $teamId) {
      user_id
      auminfo {
        user_name
        profile_url
        email
        roles
      }
    }
  }
`;

export const SEARCH_USERS = gql`
  query users($filter: String!, $skip: Int!, $limit: Int!) {
    users(filter: $filter, skip: $skip, limit: $limit) {
      users {
        user_id
        auminfo {
          user_name
          email
        }
      }
    }
  }
`;

export const GET_ROLE = gql`
  query role($roleIdentifier: InputRoleIdentifier!){
    role(roleIdentifier: $roleIdentifier){
      roleIdentifier{
        name,
        team,
        displayName
      }
    }
}
`;

export const GET_CURRENT_USER = gql`
  query currentUser {
  currentUser {
    user_id
    }
  }
`;

export default {
  GET_TEAM,
  CREATE_TEAM,
  GET_TEAMS,
  GET_USERS_FOR_TEAM,
  getAllRoles,
  GET_ROLE,
  GET_CURRENT_USER,
};
